var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10450",
    "data-name": "Group 10450",
    transform: "translate(-148 -2283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(148 2283)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_health",
    "data-name": "vuesax/outline/health",
    transform: "translate(-319 2056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "health",
    transform: "translate(492 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.906,29.563h-8.25C3.19,29.563,0,26.373,0,18.906v-8.25C0,3.19,3.19,0,10.656,0h8.25c7.466,0,10.656,3.19,10.656,10.656v8.25C29.563,26.373,26.386,29.563,18.906,29.563Zm-8.25-27.5c-6.339,0-8.594,2.255-8.594,8.594v8.25c0,6.339,2.255,8.594,8.594,8.594h8.25c6.339,0,8.594-2.255,8.594-8.594v-8.25c0-6.339-2.255-8.594-8.594-8.594Z",
    transform: "translate(1.678 1.719)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M14.039,11.3c-.33,0-1.127-.124-1.595-1.32l-1.568-3.96A1.966,1.966,0,0,0,9.281,4.938l-8.25.027a1.031,1.031,0,0,1,0-2.062l8.25-.027H9.3a4.021,4.021,0,0,1,3.52,2.392L14.066,8.43,16.9,1.253A1.751,1.751,0,0,1,18.4,0,1.725,1.725,0,0,1,20.02,1.074l1.43,2.709a2.031,2.031,0,0,0,1.526.921h5.582a1.031,1.031,0,0,1,0,2.063H22.976a4.015,4.015,0,0,1-3.341-2.021L18.563,2.71,15.675,9.984A1.837,1.837,0,0,1,14.039,11.3Z",
    transform: "translate(1.705 13.529)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H33V33H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpIcon);
export default __webpack_public_path__ + "static/media/exp-icon.38571bac4e4cf9fa9977a1530935cf4d.svg";
export { ForwardRef as ReactComponent };